import { usePendingGameAnalysisPoll } from './usePendingGameAnalysisPoll';

const PendingGameAnalysisPoll = () => {
  usePendingGameAnalysisPoll();
  return null;
};

export default PendingGameAnalysisPoll;
